import React, { useEffect, useState } from 'react'
import { GetAccess } from '../../../../Components/Utils/roles';
import { Link, useLocation, useParams } from 'react-router-dom';
import ContractLayout from './ContractLayout';
import ViewIcon from '../../../../Components/Icons/ViewIcon';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import { useFormik } from 'formik';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import * as yup from 'yup';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import NuDate from '../../../../Components/Utils/NuDate';
import MobileInvoiceIndex from '../../../Mobile/ClientManage/Contract/MobileInvoiceIndex';
import NuAmount from '../../../../Components/Utils/NuAmount';




function Invoice() {
   const { contractsViewId,invoiceOutgoingViewId } = useParams();
             
     const location = useLocation();
      const currentPage= location.state?.currentPage
      const searchQuery= location.state?.searchQuery
      const state = location.state;
    
             
   
   
                 const [params, setParams] = useState({
                //    page: page,
                //    per_page: pageCount,
                //    search:searchQuery||"",
               
                division:"",
                status:"",
                modeOfPayment:"",
                fromDate:"",
                toDate:"",
                fromDueDate:"",
                toDueDate:"",
                   approvalStatus:state?.approvalStatus? state.approvalStatus :"",
                   category:state?.category? state.category :"",
                 });
               
                
   
                   const { data,getData,dataLoading } = UseGetDataSearch( `/invoices-outgoing/contract/${contractsViewId}`,params);
                    console.log(data,"contractcli");

                    const [screenSize, setScreenSize] = useState({
                                                        width: window.innerWidth,
                                                      });
                                                    
                                                      useEffect(() => {
                                                        const handleResize = () => {
                                                          setScreenSize({
                                                            width: window.innerWidth,
                                                          });
                                                        };
                                                    
                                                        window.addEventListener("resize", handleResize);
                                                    
                                                        return () => {
                                                          window.removeEventListener("resize", handleResize);
                                                        };
                                                      }, []);
                    
    
    return (
      <>
      <ContractLayout 
           BackAccess={GetAccess("client_management_module")}
     
     >

{
  screenSize.width < "768" ?(<>
  <div className=' w-full h-[calc(100vh-175px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
  <MobileInvoiceIndex
  data={data}
  // // total={totalCount}
  // pageIndex={page}
  // setPageIndex={setPage}
  // dataCount={pageCount}
  // setDataCount={setPageCount}
  // officeId={officeId}
  getData={getData}

  />
  </div>
  </>):(<>
       <div className="overflow-x-auto mt-0.5 rounded-md bg-white h-[calc(100vh-160px)]">
       <table className="min-w-full text-xs text-left">
         <thead>
           <tr className="text-black font-semibold  border-b border-gray-300">
             <th className="px-4 py-2 w-[15.83%]">Ref.</th>
             <th className="px-4 py-2 w-[15.83%]">Client</th>
             {/* <th className="px-4 py-2 w-[15.83%]">Invoice Date</th> */}

             <th className="px-4 py-2 w-[15.83%]">Amount</th>
             <th className="px-4 py-2 w-[15.83%]">Payment Due Date</th>
             {/* <th className="px-4 py-2 w-[15.83%]">Days Elapsed</th> */}

             <th className="px-4 py-2 w-[15.83%]">Mode Of Payment</th>
             <th className="px-4 py-2 w-[15.83%]">Status</th>
             <th className="px-4 py-2 w-[5%]">Action</th>
           </tr>
         </thead>
         <tbody>
           {data.map((data) => (
             <tr key={data.id} className=" hover:bg-gray-50 rounded-md shadow-sm">
               <td className="px-4 py-2 w-[15.83%]">
                                                                <Link to={`/invoice/invoice-outgoing/view/${data?.invoiceOutId}`} >
                                                          
                                                          {data.ref || "-"}
                                                                </Link>
                                                          
                                                          </td>
                                                        <td className="px-4 py-2 w-[15.83%]">
                                                        <Link to={`/invoice/invoice-outgoing/view/${data?.invoiceOutId}`} >
                                                          
                                                          {data.clientName || "-"}
                                                          </Link>
                                                          
                                                          </td>

                                                          {/* <td className="px-4 py-2 w-[15.83%]">{data.date ? (
                                      <NuDate
                                        value={data?.paymentDueDate}
                                        format="DD-MMM-YYYY"
                                      />
                                    ) : (
                                      "N/A"
                                    )}</td> */}
               {/* <td className="px-4 py-2">{data.ref}</td>
               <td className="px-4 py-2">{data.client}</td> */}
               <td className="px-4 py-2 w-[15.83%]"><NuAmount  value={(data.amount || "-")}/></td>
 <td className="px-4 py-2">{data.date ? (
                                      <NuDate
                                        value={data?.paymentDueDate}
                                        format="DD-MMM-YYYY"
                                      />
                                    ) : (
                                      "N/A"
                                    )}</td>
               {/* <td className="px-4 py-2">{data.paymentDueDate}</td> */}
               {/* <td className="px-4 py-2 w-[15.83%]">{data.daysElapsed || "-"}</td> */}

               <td className="px-4 py-2 w-[15.83%]">{data.modeOfPayment || "-"}</td>
               <td className="px-4 py-2 w-[15.83%]">
                 {data.status || "-"}
               </td>
               <td className="px-4 py-2 w-[5%] text-gray-500">
                 <Link to={`/invoice/invoice-outgoing/view/${data?.invoiceOutId}`}
                                      state={{
                                        data: data,
                                        from: `/Contract-management/contracts/invoice/${contractsViewId}`,
                                      }}>
                                            <ViewIcon color="#048178" />

  </Link>
  </td>
             </tr>
           ))}
         </tbody>
       </table>
     </div>
   </>)}

     </ContractLayout>

   
     </>
    )
}

export default Invoice